import { render } from "./WebsiteBlocks.vue?vue&type=template&id=435d8115&scoped=true"
import script from "./WebsiteBlocks.vue?vue&type=script&lang=js"
export * from "./WebsiteBlocks.vue?vue&type=script&lang=js"

import "./WebsiteBlocks.vue?vue&type=style&index=0&id=435d8115&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435d8115"]])

export default __exports__